import React from 'react';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useProGenderInfo } from 'Douleutaras/hooks/users/pro';
import QuickButton from 'Douleutaras/components/QuickButton/QuickButton';
import { buildUrl, VALID_URLS } from 'Douleutaras/utilities/url-builder';
import { ContactModalOptions } from 'Douleutaras/constants/ccf/need-help-options';
import ModalSelectionItem from 'Douleutaras/components/modals/parts/ModalSelectionItem';
import { PhoneDropdown } from 'Douleutaras/components/PhoneDropdown/PhoneDropdown';
import { PhoneNumberRevealedSource } from 'Douleutaras/app/lib/posthog/posthog.types';

interface ContactModalContent {
  userId: string;
  jobId?: string;
  bidId?: string;
  conversationId?: string;
  phoneNumber?: string;
  hasChat?: boolean;
  hasPhone?: boolean;
  hasExtraPro?: boolean;
  wantsToPayOnline?: boolean;
  wantsToPayOnlineDisabled?: boolean;
  source?: PhoneNumberRevealedSource;
  onOptionSelected(action: ContactModalOptions): void;
}

export const ContactModalContent: React.FC<ContactModalContent> = props => {
  const {
    userId,
    jobId,
    bidId,
    conversationId,
    hasChat,
    hasPhone,
    hasExtraPro,
    wantsToPayOnline,
    wantsToPayOnlineDisabled,
    phoneNumber,
    source = PhoneNumberRevealedSource.NEED_HELP,
    onOptionSelected
  } = props;
  const navigate = useNavigate();
  const sellerGenderInfo = useProGenderInfo(userId);

  return (
    <>
      { Boolean(conversationId) && hasChat &&
        <ModalSelectionItem>
          <QuickButton
            title={<Trans values={sellerGenderInfo}>T.CCF.CONTACT CHAT BTN TEXT</Trans>}
            onClick={async () => {
              await onOptionSelected(ContactModalOptions.I_WILL_USE_THE_CHAT);
              navigate(buildUrl(VALID_URLS.CONVERSATION_THREAD, conversationId));
            }}
          />
        </ModalSelectionItem>
      }
      { Boolean(phoneNumber) && hasPhone &&
        <ModalSelectionItem>
          <PhoneDropdown phone={phoneNumber} jobId={jobId} bidId={bidId} sellerId={userId} source={source}>
            <QuickButton
              title={<Trans values={sellerGenderInfo}>T.CCF.CONTACT CALL BTN TEXT</Trans>}
              onClick={() => onOptionSelected(ContactModalOptions.I_WILL_CALL_THE_PRO)}
            />
          </PhoneDropdown>
        </ModalSelectionItem>
      }
      { hasExtraPro &&
        <ModalSelectionItem>
          <QuickButton
            preview
            title={<Trans values={sellerGenderInfo}>T.CCF.REQUEST EXTRA BID</Trans>}
            onClick={() => onOptionSelected(ContactModalOptions.I_WANT_EXTRA_PRO)}
          />
        </ModalSelectionItem>
      }
      { wantsToPayOnline &&
        <ModalSelectionItem>
          <QuickButton
            disabled={wantsToPayOnlineDisabled}
            title={<Trans values={sellerGenderInfo}>T.CCF.SEND ONLINE PAYMENT</Trans>}
            onClick={() => onOptionSelected(ContactModalOptions.I_WILL_SEND_ONLINE_PAYMENT)}
          />
        </ModalSelectionItem>
      }
    </>
  );
};
